<div class="backdrop" (click)="onClose()"></div>
<div class="utente-box">
    <mat-icon class="chiudiModale" (click)="onClose()">highlight_off</mat-icon>
    <mat-tab-group animationDuration="0ms">
        <mat-tab>
            <!-- tab Utente -->
            <ng-template mat-tab-label>
                {{ 'User' | translate}}
            </ng-template>
            <form [formGroup]="formModaleUtenti" (ngSubmit)="onSubmit()" #f="ngForm">
                <div class="form-group">
                    <label>{{ 'authPlaceholderID' | translate }}</label>
                    <span class="userVisualizzato"> {{utenteLoggato.username}} </span>
                </div>
                <div class="ordinamentoLogico">
                    <div class="form-group">
                        <!-- <label>{{ 'authPlaceholderID' | translate }}</label> -->
                        <label>{{ 'name' | translate }}</label>
                        <input class="form-control" type="text" name="text" formControlName="name" >
                    </div>
                    <div class="form-group">
                        <label>E-mail</label>
                        <input class="form-control" type="email" name="email" formControlName="email" >
                    </div>
                    <div class="form-group">
                        <label>Password</label>
                        <input class="form-control" type="password" name="password" formControlName="password" >
                    </div>
                </div>
                <div class="form-group">
                    <label>{{ 'newPwd' | translate}}</label>
                    <input matInput class="form-control controllo" [type]="hide ? 'password' : 'text' " name="Npassword"
                        formControlName="newPassword">   
                    <mat-icon matTooltip="- min 8 caratteri 
                    - una lettera maiuscola 
                    - una minuscola
                    - un numero 
                    - un carattere speciale" matTooltipClass="multilineTooltip">
                        help_outline
                    </mat-icon>
                    <button mat-icon-button [disableRipple]="true"  matSuffix class="eye no-hover-effect" (click)="hide = !hide" 
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
                    <mat-icon >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <div *ngIf="formModaleUtenti.get('newPassword').valid">
                        <mat-icon  class="iconOk">done</mat-icon>
                    </div>
                    
                    <mat-error
                        *ngIf="!formModaleUtenti.get('newPassword').valid && formModaleUtenti.get('newPassword').touched"
                        class="help-block">
                        <div *ngIf="formModaleUtenti.get('newPassword').invalid">
                            {{ 'pswRequired' | translate}}                            
                            <mat-icon class="iconError">close </mat-icon>
                        </div>
                    </mat-error>
                </div>
           
                <div class="form-group">
                    <label>{{ 'confPwd' | translate}}</label>
                    <input class="form-control Cpassword controllo" type="password" name="Cpassword"
                        formControlName="confirmedPassword">
                        <div *ngIf="formModaleUtenti.get('confirmedPassword').valid">
                            <mat-icon  class="iconOk2">done</mat-icon>
                        </div>
                    <!-- <mat-icon *ngIf="formModaleUtenti.get('confirmedPassword').valid" class="iconOk">done</mat-icon> -->
                    <mat-error
                        *ngIf="!formModaleUtenti.get('confirmedPassword').valid && formModaleUtenti.get('confirmedPassword').touched "
                        class="help-block">
                        <div *ngIf="formModaleUtenti.get('confirmedPassword').errors.required">
                            {{ 'pswRequired' | translate}}
                            <mat-icon class="iconError">close </mat-icon>
                        </div>
                        <div *ngIf="formModaleUtenti.get('confirmedPassword').errors.confirmedValidator"
                            class="alertCombaciare">
                            {{ 'pswMatch' | translate}}
                            <mat-icon class="iconError">close </mat-icon>
                        </div>
                    </mat-error>
                </div>
                <button class="btn btn-primary" type="submit" [disabled]="!bottoneAbilitato">{{ 'Save' | translate}}</button>
            </form>
        </mat-tab>
        <!-- tab Linguistica -->
        <mat-tab>
            <ng-template mat-tab-label>
                {{ 'linguistics' | translate }}
            </ng-template>
            <form [formGroup]="formLinguistica" >
            <div class="form-group">
                <label>{{'userSettingsMod.spellChecker' | translate}}</label>
                <mat-slide-toggle color="primary" formControlName="spellCheckerEnabled"></mat-slide-toggle>
            </div>
            <div class="form-group">
                <label>{{'userSettingsMod.prompter' | translate}}</label>
                <mat-slide-toggle color="primary" formControlName="suggestionEnabled"></mat-slide-toggle>
            </div>
            <div class="form-group">
                <label>{{'userSettingsMod.suggestionCount' | translate}}</label>
                <input class="number form-control" type="number" name="number1" formControlName="suggestionCount" (focusout)="saveUpdateOnFocusOut($event, 'suggestionCount')">
            </div>
            <div class="form-group percent">
                <label>{{'userSettingsMod.minRank' | translate}}</label>
                <input class="number form-control" type="number" name="number2" min="1" max="100" formControlName="suggestionMinRank" (focusout)="saveUpdateOnFocusOut($event, 'suggestionMinRank')">    
            </div>
            <div class="form-group">
                <label>{{'userSettingsMod.showRankPerc' | translate}}</label>
                <!-- <input class="checkbox" type="checkbox" name="radio1" formControlName="suggestionRankVisible"> -->
                <mat-checkbox disableRipple=true class="checkbox" type="checkbox" name="radio1" formControlName="suggestionRankVisible"></mat-checkbox>
            </div>
            <div class="form-group">
                <label>{{'userSettingsMod.useDistSemantics' | translate}}</label>
                <!-- <input class="checkbox" type="checkbox" name="radio2" formControlName="suggestionUseCosines"> -->
                <mat-checkbox disableRipple=true class="checkbox" type="checkbox" name="radio2" formControlName="suggestionUseCosines"></mat-checkbox>
            </div>
        </form>
        </mat-tab>
    </mat-tab-group>
</div>